import { httpClient, type PaymentMethodResponse } from '@ahm/api-wrappers-core';
import { apiRoutes } from '@/api/api-routes';

export const getCheckoutPaymentMethodFn = async (type: string) => {
  const response = await httpClient.get<PaymentMethodResponse>(
    apiRoutes.payment.getCheckoutPaymentMethod(type)
  );

  if (response.data?.status === 'success') {
    return response.data.data;
  }

  return [];
};
